@file:OptIn(InternalResourceApi::class)

package tuner.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/tuner.sharedui.generated.resources/"

internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 24),
      ))
    }

internal val Res.string.classic_guitar: StringResource by lazy {
      StringResource("string:classic_guitar", "classic_guitar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35, 46),
      ))
    }

internal val Res.string.high: StringResource by lazy {
      StringResource("string:high", "high", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82, 20),
      ))
    }

internal val Res.string.low: StringResource by lazy {
      StringResource("string:low", "low", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103, 15),
      ))
    }

internal val Res.string.match: StringResource by lazy {
      StringResource("string:match", "match", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119, 21),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("classic_guitar", Res.string.classic_guitar)
  map.put("high", Res.string.high)
  map.put("low", Res.string.low)
  map.put("match", Res.string.match)
}
